import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AppCollectionCarousel } from '../../components/AppCollectionCarousel';
import { useAppCollections } from '../../contexts/providers/collection';
import { Helmet } from 'react-helmet';
import { AppCollectionStyles, AppCollectionGroup } from '../../models/enums';
import { SnackCard } from '../../components/SnackCard';
import { groupBy } from '../../utils/transformationHelper';
import { PageInfo } from '../../components/Header/PageInfo';
import { SetPageTitle } from '../../components/Common/SetPageTitle';

export const PublicAppmarketPage = (): JSX.Element => {
  const { collections } = useAppCollections();
  const [t] = useTranslation();
  const canonicalURL = document.location.href.replace(/\/+$/, '');
  const csrfToken = sessionStorage.getItem('csrfToken');
  const snackCardApp = useMemo(() => {
    return collections.filter((collection) => {
      const { collectionGroup, collectionStyle } = collection;
      if (!collectionGroup || !collectionStyle) return;
      return collectionStyle === AppCollectionStyles.VerticalGrid &&
        (collectionGroup === AppCollectionGroup.Customer || collection.collectionGroup === AppCollectionGroup.Employee || collection.collectionGroup === AppCollectionGroup.EssentialTool);
    });
  }, [collections]);
  const snackCardCollection = useMemo(() => groupBy(snackCardApp, i => i.collectionGroup || ''), [snackCardApp]);
  const defaultPageMetaDescription = t('clover_app_store.default_page_meta_description');

  return (
    <>
    <SetPageTitle/>
      <PageInfo/>
      {!csrfToken && (
        <Helmet>
          <link rel="canonical" href={canonicalURL} />
          <meta
              name="description"
              content={defaultPageMetaDescription}
          />
          <meta
              name="keywords"
              content="Clover App Market, App Market"
          />
        </Helmet>
      )}
      {collections.map(collection => (
        <AppCollectionCarousel collection={collection} key={collection.id} />
      ))}
      {Object.entries(snackCardCollection).map(([collectionGroup, snackCard]) => (
        <SnackCard collection={snackCard} groupName={collectionGroup} key={collectionGroup} />
      ))}
    </>
  );
};
